import { combineReducers } from "redux"
import { buckets } from './bucketsReducer'

const xdataReducers = combineReducers({
    buckets
})

export default xdataReducers